 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/text/Title'
 import TEXTCOPYRIGHT from '@/components/text/Copyright'
 import TEXTDEDICATION from '@/components/text/Dedication'
 import TEXTCONTENTS from '@/components/text/Contents'
 import TEXTINTRODUCTION from '@/components/text/Introduction'
 import TEXTCHAPTER001 from '@/components/text/Chapter001'
 import TEXTCHAPTER002 from '@/components/text/Chapter002'
 import TEXTCHAPTER003 from '@/components/text/Chapter003'
 import TEXTCHAPTER004 from '@/components/text/Chapter004'
 import TEXTCHAPTER00401 from '@/components/text/Chapter004-01'
 import TEXTCHAPTER00402 from '@/components/text/Chapter004-02'
 import TEXTCHAPTER00403 from '@/components/text/Chapter004-03'
 import TEXTCHAPTER00404 from '@/components/text/Chapter004-04'
 import TEXTCHAPTER00405 from '@/components/text/Chapter004-05'
 import TEXTCHAPTER00406 from '@/components/text/Chapter004-06'
 import TEXTCHAPTER00407 from '@/components/text/Chapter004-07'
 import TEXTCHAPTER00408 from '@/components/text/Chapter004-08'
 import TEXTCHAPTER00409 from '@/components/text/Chapter004-09'
 import TEXTCHAPTER00410 from '@/components/text/Chapter004-10'
 import TEXTCHAPTER00411 from '@/components/text/Chapter004-11'
 import TEXTCHAPTER00412 from '@/components/text/Chapter004-12'
 import TEXTCHAPTER00413 from '@/components/text/Chapter004-13'
 import TEXTCHAPTER00414 from '@/components/text/Chapter004-14'
 import TEXTCHAPTER00415 from '@/components/text/Chapter004-15'
 import TEXTCHAPTER00416 from '@/components/text/Chapter004-16'
 import TEXTCHAPTER00417 from '@/components/text/Chapter004-17'
 import TEXTCHAPTER005 from '@/components/text/Chapter005'
 import TEXTCHAPTER00501 from '@/components/text/Chapter005-01'
 import TEXTCHAPTER00502 from '@/components/text/Chapter005-02'
 import TEXTCHAPTER00503 from '@/components/text/Chapter005-03'
 import TEXTCHAPTER00504 from '@/components/text/Chapter005-04'
 import TEXTCHAPTER00505 from '@/components/text/Chapter005-05'
 import TEXTCHAPTER00506 from '@/components/text/Chapter005-06'
 import TEXTCHAPTER00507 from '@/components/text/Chapter005-07'
 import TEXTCHAPTER00508 from '@/components/text/Chapter005-08'
 import TEXTCHAPTER00509 from '@/components/text/Chapter005-09'
 import TEXTCHAPTER00510 from '@/components/text/Chapter005-10'
 import TEXTCHAPTER00511 from '@/components/text/Chapter005-11'
 import TEXTCHAPTER00512 from '@/components/text/Chapter005-12'
 import TEXTCHAPTER00513 from '@/components/text/Chapter005-13'
 import TEXTCHAPTER00514 from '@/components/text/Chapter005-14'
 import TEXTCHAPTER00515 from '@/components/text/Chapter005-15'
 import TEXTCHAPTER00516 from '@/components/text/Chapter005-16'
 import TEXTCHAPTER00517 from '@/components/text/Chapter005-17'
 import TEXTCHAPTER00518 from '@/components/text/Chapter005-18'
 import TEXTCHAPTER00519 from '@/components/text/Chapter005-19'
 import TEXTCHAPTER00520 from '@/components/text/Chapter005-20'
 import TEXTCHAPTER00521 from '@/components/text/Chapter005-21'
 import TEXTCHAPTER00522 from '@/components/text/Chapter005-22'
 import TEXTCHAPTER00523 from '@/components/text/Chapter005-23'
 import TEXTCHAPTER00524 from '@/components/text/Chapter005-24'
 import TEXTCHAPTER006 from '@/components/text/Chapter006'
 import TEXTCHAPTER00601 from '@/components/text/Chapter006-01'
 import TEXTCHAPTER00602 from '@/components/text/Chapter006-02'
 import TEXTCHAPTER00603 from '@/components/text/Chapter006-03'
 import TEXTCHAPTER00604 from '@/components/text/Chapter006-04'
 import TEXTCHAPTER007 from '@/components/text/Chapter007'
 import TEXTCHAPTER00701 from '@/components/text/Chapter007-01'
 import TEXTCHAPTER00702 from '@/components/text/Chapter007-02'
 import TEXTCHAPTER00703 from '@/components/text/Chapter007-03'
 import TEXTCHAPTER00704 from '@/components/text/Chapter007-04'
 import TEXTCHAPTER00705 from '@/components/text/Chapter007-05'
 import TEXTCHAPTER00706 from '@/components/text/Chapter007-06'
 import TEXTCHAPTER00707 from '@/components/text/Chapter007-07'
 import TEXTCHAPTER00708 from '@/components/text/Chapter007-08'
 import TEXTCHAPTER00709 from '@/components/text/Chapter007-09'
 import TEXTCHAPTER00710 from '@/components/text/Chapter007-10'
 import TEXTCHAPTER00711 from '@/components/text/Chapter007-11'
 import TEXTCHAPTER00712 from '@/components/text/Chapter007-12'
 import TEXTCHAPTER00713 from '@/components/text/Chapter007-13'
 import TEXTCHAPTER00714 from '@/components/text/Chapter007-14'
 import TEXTCHAPTER00715 from '@/components/text/Chapter007-15'
 import TEXTCHAPTER00716 from '@/components/text/Chapter007-16'
 import TEXTCHAPTER00717 from '@/components/text/Chapter007-17'
 import TEXTCHAPTER00718 from '@/components/text/Chapter007-18'
 import TEXTCHAPTER00719 from '@/components/text/Chapter007-19'
 import TEXTCHAPTER00720 from '@/components/text/Chapter007-20'
 import TEXTCHAPTER008 from '@/components/text/Chapter008'
 import TEXTCHAPTER00801 from '@/components/text/Chapter008-01'
 import TEXTCHAPTER00802 from '@/components/text/Chapter008-02'
 import TEXTCHAPTER00803 from '@/components/text/Chapter008-03'
 import TEXTCHAPTER00804 from '@/components/text/Chapter008-04'
 import TEXTCHAPTER00805 from '@/components/text/Chapter008-05'
 import TEXTCHAPTER00806 from '@/components/text/Chapter008-06'
 import TEXTCHAPTER00807 from '@/components/text/Chapter008-07'
 import TEXTCHAPTER00808 from '@/components/text/Chapter008-08'
 import TEXTCHAPTER009 from '@/components/text/Chapter009'
 import TEXTCHAPTER00901 from '@/components/text/Chapter009-01'
 import TEXTCHAPTER00902 from '@/components/text/Chapter009-02'
 import TEXTCHAPTER00903 from '@/components/text/Chapter009-03'
 import TEXTCHAPTER00904 from '@/components/text/Chapter009-04'
 import TEXTCHAPTER00905 from '@/components/text/Chapter009-05'
 import TEXTCHAPTER00906 from '@/components/text/Chapter009-06'
 import TEXTCHAPTER00907 from '@/components/text/Chapter009-07'
 import TEXTCHAPTER00908 from '@/components/text/Chapter009-08'
 import TEXTCHAPTER00909 from '@/components/text/Chapter009-09'
 import TEXTCHAPTER00910 from '@/components/text/Chapter009-10'
 import TEXTCHAPTER00911 from '@/components/text/Chapter009-11'
 import TEXTCHAPTER010 from '@/components/text/Chapter010'
 import TEXTCHAPTER01001 from '@/components/text/Chapter010-01'
 import TEXTCHAPTER01002 from '@/components/text/Chapter010-02'
 import TEXTCHAPTER01003 from '@/components/text/Chapter010-03'
 import TEXTCHAPTER01004 from '@/components/text/Chapter010-04'
 import TEXTCHAPTER01005 from '@/components/text/Chapter010-05'
 import TEXTCHAPTER01006 from '@/components/text/Chapter010-06'
 import TEXTCHAPTER01007 from '@/components/text/Chapter010-07'
 import TEXTCHAPTER01008 from '@/components/text/Chapter010-08'
 import TEXTCHAPTER01009 from '@/components/text/Chapter010-09'
 import TEXTCHAPTER01010 from '@/components/text/Chapter010-10'
 import TEXTCHAPTER01011 from '@/components/text/Chapter010-11'
 import TEXTCHAPTER01012 from '@/components/text/Chapter010-12'
 import TEXTCHAPTER01013 from '@/components/text/Chapter010-13'
 import TEXTCHAPTER01014 from '@/components/text/Chapter010-14'
 import TEXTCHAPTER01015 from '@/components/text/Chapter010-15'
 import TEXTCHAPTER01016 from '@/components/text/Chapter010-16'
 import LOVE_2 from '@/components/love_2'
 import TEXTACKNOWLEDGMENTS from '@/components/text/Acknowledgments'
 import TEXTABOUT_THE_AUTHOR from '@/components/text/About_the_Author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/Contents",
 			"name" : "text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/text/Introduction",
 			"name" : "text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/text/Chapter001",
 			"name" : "text/Chapter001",
 			"component" : TEXTCHAPTER001
 		},
 		{
 			"path" : "/text/Chapter002",
 			"name" : "text/Chapter002",
 			"component" : TEXTCHAPTER002
 		},
 		{
 			"path" : "/text/Chapter003",
 			"name" : "text/Chapter003",
 			"component" : TEXTCHAPTER003
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js